// extracted by mini-css-extract-plugin
module.exports = {"container":"BusinessPageHelp_container__dk4Iw","stickyContainer":"BusinessPageHelp_stickyContainer__EZe5q","roundedButton":"BusinessPageHelp_roundedButton__zwBnF"};